import { Injectable } from '@angular/core';
import { PostcodeManagerService } from './postcode-manager.service';
import { ServiceTypes } from './globals.service';
import { environment } from '../../environments/environment';
import { Clients, QuestionTypes, TradeTypes } from '../services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class PricingService {
  public ServiceTypes: typeof ServiceTypes = ServiceTypes;

  public postcodeManager: PostcodeManagerService = null;

  public clients: Clients = null;

  constructor(_postcodeManager: PostcodeManagerService, _clients: Clients) {
    this.postcodeManager = _postcodeManager;
    this.clients = _clients;
  }
}

export class TradeTypePricing {
  public id: number = 0;

  public jobTypes: Array<JobTypePricing> = [];

  public hourlyRate: number = 0;
  public calloutFee: number = 0;

  // out of hours
  public oohHourlyRate: number = 0;
  public oohCalloutFee: number = 0;
}

export class JobTypePricing {
  public id: number = 0;

  public triageQuestions: Array<TriageQuestionPricing> = [];

  public partsCostBase: number = 0;
  public partsCostPremium: number = 0;
  public attendanceHours: number = 1;

  public additionalCalloutFee: number = 0;
}

export class TriageQuestionPricing {
  public additionalFixedCost: number = 0;
  public additionalPerCost: number = 0;

  public modifiedBasePartsCost: number = 0;
  public modifiedPremiumPartsCost: number = 0;

  public hourlyMultiplier: number = 0;
  public partsMultiplier: number = 0;
  public partsAdd: number = 0;
}
